<div [ngClass]="'alert-header'">
    <span [ngClass]="'alert-title'"> {{data.alertTitle}} </span>
</div>
<div [ngClass]="'alert-body'"> 
    <div> {{data.alertText}} </div>    
    <div [ngClass]="'waiting-box'">
        <mat-spinner [diameter]="100"/>
    </div>
</div>